<template>
	<div>
		<GlobalHeader />
		<AboutUsHero />
		<LazyVisibleAboutUsGallery hydrate-on-visible />
		<!-- <AboutUsTeam /> -->
		<LazyVisibleAboutUsPlaces hydrate-on-visible />
		<LazyVisibleGlobalNewsSection hydrate-on-visible />
		<LazyVisibleAboutUsJob hydrate-on-visible />
		<LazyVisibleGlobalFooter hydrate-on-visible />
	</div>
</template>
<script lang="ts" setup>
const config = useNuxtApp().$config
const route = useRoute()
const $t = useI18n().t

const robotsMeta = config.public.environment === 'production-to-change' ? 'index, follow' : 'noindex, nofollow'

useHead({
	title: $t('pages.about_us.meta_title') + ' | CarFree',
	link: [
		{
			rel: 'canonical',
			href: config.public.baseURL + route.fullPath,
		},
	],
	meta: [
		{ name: 'robots', content: robotsMeta },
		{
			name: 'description',
			content: $t('pages.about_us.meta_description'),
		},
		{ property: 'og:title', content: $t('pages.about_us.meta_title') + ' | CarFree' },
		{
			property: 'og:description',
			content: $t('pages.about_us.meta_description'),
		},
	],
})
</script>
